import { FORM_PATHS, openInModalOrPage } from '../../modals';
import { createFakeId } from '../../../reducers/util';

export const CREATE_COMMUNICATION_TYPE_COMMUNICATION = 'Communication';

export const createCommunication = companyId => dispatch => {
    dispatch(openInModalOrPage(FORM_PATHS.EditCommunicationModal, createFakeId(), {}, companyId));
};
